import Section from "../../Section";
import SecondaryTitle from "../../Titles/SecondaryTitle";
import Button from '../../Button'

const OurCommitment = () => {
  return (
    <Section className='bg-ourcommitment relative flex flex-col justify-center text-center py-20'>
      <div className='max-w-screen-xl mx-auto px-6 lg:px-16 flex flex-col space-y-12 relative z-10'>

        {/* Accent Indicator */}
        <div className='inline-block mx-auto mb-4'>
          <span className='text-accent-gold text-sm uppercase font-semibold tracking-widest'>Our Promise</span>
        </div>

        <SecondaryTitle
          title='Committed to Excellence'
          animation='fade-left'
          className='text-text-light drop-shadow-lg'
        />

        <div className='luxury-divider mx-auto'></div>

        <div className='mx-auto w-full lg:w-3/4 lg:px-4 z-50'>
          <p className='paragraph text-sm sm:text-base md:text-lg lg:text-xl text-text-primary text-center'>
            We are dedicated to providing exceptional services that enhance your natural beauty, with meticulous attention to detail and your satisfaction as our priority. Every client deserves premium care.
          </p>
        </div>

        {/* CTA Button */}
        <div className='mt-12 drop-shadow-lg w-full md:w-auto mx-auto flex justify-center'>
          <Button
            title='Learn More About Us'
            link='/onama'
            className='btn-primary px-12 py-4 text-lg'
          />
        </div>
      </div>
    </Section>
  );
};

export default OurCommitment;
